import { Link } from '@tanstack/react-router';
import { ErrorComponentProps } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import * as Sentry from '@sentry/react';


export default function ErrorComponent({ error, reset }: ErrorComponentProps) {
  const { t } = useTranslation();

  Sentry.captureException(error);
  console.error('ErrorComponent', error);

  return (
    <div className="flex flex-col items-center justify-center min-h-[100dvh] text-gray-950 p-4">
      <div className="max-w-md w-full space-y-6 text-center">
        <div className="space-y-2">
          <h1 className="text-4xl font-bold">
            {t('pages.error.oops_something_went_wrong')}
          </h1>
          <p className="text-gray-700">
            {t('pages.error.please_try_again_later')}
          </p>
        </div>
        <button
          onClick={reset}
          className="inline-flex h-10 items-center justify-center rounded-md bg-background-1 px-6 text-sm font-medium text-white shadow transition-colors hover:bg-background-1/80 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-gray-950 disabled:pointer-events-none disabled:opacity-50"
        >
          {t('pages.error.retry')}
        </button>
        <Link
          to="/"
          className="inline-flex h-10 items-center justify-center rounded-md bg-background-1 px-6 text-sm font-medium text-white shadow transition-colors hover:bg-background-1/80 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-gray-950 disabled:pointer-events-none disabled:opacity-50"
          preload={false}
        >
          {t('pages.error.go_back_to_home')}
        </Link>
      </div>
    </div>
  );
}
